<!--
 * @Author: DY
 * @Date: 2025-01-20 19:19:48
 * @LastEditTime: 2025-03-06 11:05:33
 * @Description: 采购计划汇总
 * @FilePath: \ShiMo_Mobile\src\views\configFormRefactoring\procurementPlanSummary.vue
-->
<template>
    <div class="procurementPlanSummary">
        <van-nav-bar left-arrow title="采购计划汇总" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright"></van-nav-bar>
        <section>
            <table>
                <thead>
                    <tr>
                        <th colspan="3" style="text-align: left;">
                            概要汇总
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>本月采购计划不含税金额（万元）</th>
                        <th>本年月均采购不含税金额（万元）</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>合计</th>
                        <td>{{ formData.BudgetTotalNotax | handlingDecimals }}</td>
                        <td>{{ formData.BudgetTotalMonth | handlingDecimals }}</td>
                    </tr>
                    <tr>
                        <th>黑龙江</th>
                        <td>{{ formData.BudgetTotalNotax1 | handlingDecimals }}</td>
                        <td>{{ formData.BudgetTotalMonth1 | handlingDecimals }}</td>
                    </tr>
                    <tr>
                        <th>黑龙江</th>
                        <td>{{ formData.BudgetTotalNotax2 | handlingDecimals }}</td>
                        <td>{{ formData.BudgetTotalMonth2 | handlingDecimals }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </div>
</template>

<script>
export default {
    name: 'procurement-plan-summary',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backPathName = from.name;
        });
    },
    components: {},
    data() {
        return {
            listData: {},
            formData: {},
            backPathName: '',
        };
    },
    watch: {},
    filters: {
        handlingDecimals(val) {
            return (val / 10000).toFixed(6).replace(/[.]0*$/, '');
        },
    },
    async created() {
        this.listData = this.$route.params.listData;
        this.formData = await this.getFormData(this.listData.FormKeyValue);
    },
    mounted() {},
    computed: {},
    methods: {
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
            this.$router.go(-1);
        },
        getFormData(id) {
            const url = `/interfaceApi/procurement/plan_collect_huge/all?id=${id}`;
            return this.$axios.$get(url, { token: this.newsToken, defEx: true });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.procurementPlanSummary
    section
        padding 10rpx
        table
            border-collapse: collapse
            th,td
                padding 0 5rpx
                height: 36rpx
                font-size: 14rpx
                color: #333333
                font-weight: 400
                border 1px solid #D7D7D7
            th
                background: #f2f5f6
            tbody
                th
                    width 70rpx
</style>
